module.exports = __webpack_public_path__ + "static/media/drinks.54b15f7c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/drinks.svg
// module id = 68
// module chunks = 0